<div class="btn-group" [hidden]="(isVisible$ | async) === false"
    *ngIf="{position: HsLayoutService.sidebarPosition | async} as sidebar">
    <button class="btn rounded-0 btn-light hs-toolbar-button"
        [ngClass]="HsDrawService.highlightDrawButton ? 'btn-outline-danger' : 'btn-outline-secondary'"
        (click)="toggleDrawToolbar()">
        <i [ngClass]="{'icon-pencil':!drawToolbarExpanded, 'icon-remove':drawToolbarExpanded}" data-toggle="tooltip"
            [title]="'PANEL_HEADER.DRAW' | translateHs "></i></button>
    <div class="btn-group" *ngIf="drawToolbarExpanded">
        <div class="btn-group" ngbDropdown placement="bottom-left" display="dynamic">
            <button type="button" ngbDropdownToggle
                class="btn btn-light rounded-0 btn-secondary dropdown-toggle hs-draw-layer-toggle d-flex align-items-center"
                [hidden]="!(HsDrawService.hasSomeDrawables || HsDrawService.tmpDrawLayer)"
                (click)="controlLayerListAction(); HsDrawService.fillDrawableLayers() "
                style="max-width: 125px; overflow: hidden; font-size: 0.9rem; z-index: 2;"
                [ngClass]="HsDrawService.tmpDrawLayer ? 'btn-outline-danger' : 'btn-outline-primary'">
                <div class="text-truncate pe-1">{{HsDrawService.selectedLayerString()}}</div>
            </button>
            <div ngbDropdownMenu class="dropdown-menu" style="max-width: 20em;">
                <div class="d-flex align-items-center w-100 flex-column"
                    *ngIf="HsDrawService.drawableLayers.length > 0">
                    <label class=" bg-primary w-100 text-light m-0 p-1">{{'DRAW.activeLayers' | translateHs
                        }}</label>
                    <a class="dropdown-item text-truncate" *ngFor="let layer of HsDrawService.drawableLayers"
                        (click)="selectLayer(layer)">{{getTitle(layer) | translateHs : {module: 'LAYERS'}
                        }}</a>
                </div>
                <div class="d-flex align-items-center w-100 flex-column"
                    *ngIf="HsDrawService.drawableLaymanLayers.length > 0">
                    <div class=" bg-primary w-100 text-light m-0 p-1">
                        <div class="d-flex justify-content-between">
                            {{'DRAW.serverLayers' | translateHs }}
                            <span (click)="onlyMineFilterVisible = !onlyMineFilterVisible" style="cursor: pointer;">
                                <i class="icon-settingsthree-gears"></i>
                            </span>
                        </div>
                        <div class="p-0 input-group-text border-0 justify-content-center bg-white"
                            *ngIf="onlyMineFilterVisible">
                            <label class="m-0">
                                <input type="checkbox" name="onlyMine" [(ngModel)]="HsDrawService.onlyMine"
                                    (ngModelChange)="HsDrawService.fillDrawableLayers(); onlyMineFilterVisible = !onlyMineFilterVisible">
                                {{'COMPOSITIONS.onlyMine' | translateHs }}
                            </label>
                        </div>
                    </div>
                    <a class="dropdown-item  text-truncate" *ngFor="let layer of HsDrawService.drawableLaymanLayers"
                        (click)="selectLayer(layer)">{{layer.title | translateHs : {module: 'LAYERS'}
                        }}</a>
                </div>
            </div>
        </div>

        <button class="btn btn-light hs-toolbar-button btn-outline-secondary" [hidden]="HsDrawService.tmpDrawLayer"
            (click)="HsDrawService.saveDrawingLayer()" data-toggle="tooltip"
            [title]="'DRAW.drawToolbar.addDrawLayer' | translateHs ">
            <i class="icon-plus"></i></button>
        <button type="button" *ngIf="HsDrawService.tmpDrawLayer"
            class="btn btn-light  hs-toolbar-button  btn-outline-secondary" (click)="HsDrawService.saveDrawingLayer()"
            [title]="'DRAW.saveDrawingToLayer' | translateHs ">
            <i class="glyphicon icon-save-floppy"></i>
        </button>
        <ng-container *ngIf="HsDrawService.hasSomeDrawables">
            <ng-container *ngIf="HsDrawService.moreThenOneDrawable === true; else deleteButton">
                <div class="btn-group">
                    <div ngbDropdown placement="bottom-right" display="dynamic" style="white-space: nowrap;"
                        #removeLayersDropdown="ngbDropdown">
                        <button type="button" ngbDropdownToggle
                            class="btn btn-light hs-toolbar-button rounded-0 btn-outline-secondary">
                            <i class="glyphicon icon-trash"></i>
                        </button>
                        <div ngbDropdownMenu class="flex-column px-1 py-2">
                            <div class="d-flex align-items-center w-100 flex-column">
                                <a class="dropdown-item" *ngIf="HsDrawService.selectedLayer"
                                    (click)="HsRemoveLayerDialogService.removeLayer(); removeLayersDropdown.close()">{{'COMMON.removeLayer'
                                    |
                                    translateHs }}</a>
                                <a class="dropdown-item"
                                    (click)="HsRemoveLayerDialogService.removeMultipleLayers(); removeLayersDropdown.close()">{{'DRAW.removeMultipleLayers'
                                    | translateHs }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #deleteButton>
                <button type="button" class="btn btn-light hs-toolbar-button rounded-0 btn-outline-secondary"
                    (click)="HsRemoveLayerDialogService.removeLayer()" [title]="'COMMON.removeLayer' | translateHs ">
                    <i class="glyphicon icon-trash"></i>
                </button>
            </ng-template>
        </ng-container>
        <div class="btn-group">
            <div ngbDropdown placement="bottom-right" display="dynamic" style="white-space: nowrap;"
                #selectionTypeDropdown="ngbDropdown">
                <button type="button" ngbDropdownToggle [ngClass]="{active: !HsDrawService.type }"
                    [title]="'STYLER.selection' | translateHs "
                    class="btn btn-light hs-toolbar-button btn-outline-secondary rounded-0"
                    (click)="$event.preventDefault(); selectionMenuToggled()">
                    <i class="icon-cursor"></i>
                </button>
                <div ngbDropdownMenu class="flex-column px-1 py-2">
                    <div class="d-flex flex-row justify-content-around align-items-baseline">
                        <label class="ms-1 cursor-pointer" for="draw-boxSelection"> {{'DRAW.boxSelection' |
                            translateHs }}</label>
                        <input type="checkbox" [(ngModel)]="HsDrawService.boxSelectionActive"
                            (change)="HsDrawService.toggleBoxSelection(); selectionTypeDropdown.close()"
                            id="draw-boxSelection" name="filterByExtent" class="cursor-pointer">
                    </div>
                    <button class="btn btn-primary btn-sm hs-draw-selectAll w-100"
                        [disabled]="!HsDrawService.selectedLayer"
                        (click)="HsDrawService.selectAllFeatures(); selectionTypeDropdown.close()" data-toggle="tooltip"
                        [title]="'STYLER.selection' | translateHs ">
                        {{translateString('DRAW',HsDrawService.toggleSelectionString)}}<!-- TODO: Remove function call from template -->
                    </button>
                </div>
            </div>
        </div>
        <div class="btn-group" ngbDropdown placement="bottom" display="dynamic" *ngIf="drawToolbarExpanded"
            #geometryTypeDropdown="ngbDropdown">
            <div style="top: 35vh;" role="group" class="btn-group-vertical position-fixed d-flex flex-column"
                [ngStyle]="sidebar.position === 'right' || sidebar.position === 'bottom' ? {'left': 0} : {'right': 0} ">
                <button class="btn btn-secondary" *ngIf="HsDrawService.drawActive"
                    (click)="HsDrawService.removeLastPoint()" data-toggle="tooltip"
                    [title]="'DRAW.drawToolbar.removeLastPoint' | translateHs ">
                    <i class="icon-remove-circle"></i></button>
                <button class="btn btn-secondary" *ngIf="HsDrawService.drawActive" (click)="finishDrawing()"
                    data-toggle="tooltip" [title]="'DRAW.drawToolbar.finishFeature' | translateHs ">
                    <i class="icon-check"></i></button>
            </div>
            <button ngbDropdownToggle type="button" data-test="Geometry menu" style="line-height: 1 !important;"
                [ngClass]="{active: HsDrawService.type }" class="btn  btn-light rounded-0 btn-outline-secondary"
                aria-haspopup="true">
                <label *ngIf="!HsDrawService.type" class="m-0">{{'DRAW.drawToolbar.selectType' | translateHs }}</label>
                <i [ngClass]="{
                    'icon-pin': HsDrawService.type==='Point',
                    'icon-polygonlasso': HsDrawService.type==='Polygon',
                    'icon-line': HsDrawService.type==='LineString'
                }"></i>
            </button>
            <div ngbDropdownMenu class="p-0" style="min-width: unset;">
                <div class="btn-group">
                    <button class="btn btn-light hs-toolbar-button btn-outline-secondary"
                        [ngClass]="{active: HsDrawService.type==='Point' }"
                        (click)="setType('Point'); geometryTypeDropdown.close()" data-toggle="tooltip"
                        [title]="'COMMON.point' | translateHs "><i class="icon-pin"></i></button>
                    <button class="btn btn-light hs-toolbar-button btn-outline-secondary"
                        [ngClass]="{active: HsDrawService.type==='Polygon' }"
                        (click)="setType('Polygon'); geometryTypeDropdown.close()" data-toggle="tooltip"
                        [title]="'COMMON.polygon' | translateHs "><i class="icon-polygonlasso"></i></button>
                    <button class="btn btn-light hs-toolbar-button btn-outline-secondary"
                        [ngClass]="{active: HsDrawService.type==='LineString' }"
                        (click)="setType('LineString'); geometryTypeDropdown.close()" data-toggle="tooltip"
                        [title]="'COMMON.line' | translateHs ">
                        <i class="icon-line"></i></button>
                </div>
            </div>
        </div>
    </div>

</div>